///
/// EarthBrowser
///
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

import { ViewThumbnailStore } from "@/earthbrowser/camera-director/ViewThumbnailStore"
import { useEffect, useState } from "react"

/**
 * Loads a saved view's thumbnail from the local IndexedDB cache as an
 * object URL. Returns null while loading or when this device never
 * captured the view (thumbnails are a local cache, not synced) - callers
 * show a placeholder in that case.
 */
export function useViewThumbnail(viewId: string): string | null {
	const [url, setUrl] = useState<string | null>(null)

	useEffect(() => {
		let objectUrl: string | null = null
		let cancelled = false

		ViewThumbnailStore.shared.getThumbnail(viewId)
			.then(blob => {
				if (cancelled || !blob) return
				objectUrl = URL.createObjectURL(blob)
				setUrl(objectUrl)
			})
			.catch(() => undefined)

		return () => {
			cancelled = true
			if (objectUrl) URL.revokeObjectURL(objectUrl)
			setUrl(null)
		}
	}, [viewId])

	return url
}
